module.exports = __webpack_public_path__ + "static/media/xlsx.628d8c7e.svg";